import React, { useEffect, useState } from "react";
import { Checkbox, Box, Typography } from "@mui/material";
import { setModalOpen } from "@/store/slices/globalSlice";
import Modal from "@/components/Modal/Modal";
import { useAppDispatch } from "@/store/hooks";

interface Props {
  open: boolean;
  initialSelected: string[];
  objectiveOptions: { value: string; label: string }[];
  onSave: (val: string[]) => void;
}

const TimelineObjectiveModal: React.FC<Props> = ({
  open,
  initialSelected,
  objectiveOptions,
  onSave
}) => {
  const dispatch = useAppDispatch();
  const [tempObjectives, setTempObjectives] = useState<string[]>([]);

  useEffect(() => {
    if (open) setTempObjectives(initialSelected);
  }, [open, initialSelected]);

  const toggleTemp = (value: string) => {
    setTempObjectives(prev =>
      prev.includes(value)
        ? prev.filter(v => v !== value)
        : [...prev, value]
    );
  };

  const handleDone = () => {
    onSave(tempObjectives);
    dispatch(setModalOpen({ id: null, data: null }));
  };

  return (
    <Modal
      modalOpen={open}
      closeModal={() => dispatch(setModalOpen({ id: null, data: null }))}
      heading="Call Objectives"
      saveButtonText="Done"
      width="400px"
      onSave={handleDone}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "30vh" }}>
        {objectiveOptions.length === 0 && (
          <Typography align="center" sx={{ mt: 2 }}>
            No objectives available
          </Typography>
        )}

        {objectiveOptions.map((opt: any) => (
          <Box
            key={opt.value}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 1
            }}
          >
            <Typography sx={{ textTransform: "capitalize", fontSize: 12 }}>
              {opt.label}
            </Typography>
            <Checkbox
              checked={tempObjectives.includes(opt.value)}
              onChange={() => toggleTemp(opt.value)}
            />
          </Box>
        ))}
      </Box>
    </Modal>
  );
};

export default TimelineObjectiveModal;
